export default __webpack_public_path__ + "static/media/upiria_logo_Symbol_Black_white.d16bd5e8.svg";